import {create} from "zustand";

export const useWaitListStore = create((set) => ({
    // Модальное окно "Успешное добавление в лист ожидания"
    modalState: {
        open: false,
        title: '',
        message: '',
    },

    /**
     * Открыть модальное окно "Успешное добавление в лист ожидания"
     */
    openAddWaitListModal: ({title, message}) => set({
        modalState: {
            open: true,
            title,
            message
        }
    }),
    /**
     * Закрыть модальное окно "Успешное добавление в лист ожидания"
     */
    closeAddWaitListModal: () => set({
        modalState: {
            open: false,
            title: '',
            message: ''
        }
    }),
}));
